import useFeature from '~/client/hooks/feature/useFeature';
import Cookie from '~/shared/utils/Cookie';
import PrivacyPolicyLink from '../PrivacyPolicyLink';
import TermsLink from '../TermsLink';

const TermsAndPolicyLinks = () => {
  const isShortSignUpEnabled = Cookie.get('shortSignUpForm');
  const isFastSignUpEnabled = useFeature('isFastSignUpEnabled');

  if (
    isShortSignUpEnabled &&
    !!parseInt(isShortSignUpEnabled) &&
    isFastSignUpEnabled
  ) {
    return null;
  }
  return (
    <>
      <TermsLink />
      <PrivacyPolicyLink />
    </>
  );
};

export default TermsAndPolicyLinks;
